<div class="grid-filter">
  <div class="actions">
    <div class="row">
      <div class="col-md-6 flex-align-center">
        <mat-form-field >
          <mat-label>Store No</mat-label>
          <mat-select [(ngModel)]="selectedValue" name="food" disableOptionCentering>
            @for (food of foods; track food) {
              <mat-option [value]="food.value">
                {{ food.viewValue }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <button
          mat-raised-button

          class="ml-2 mt-2 ml-sm-auto"
          >
          Filter
        </button>

      </div>
      <div class="col-md-6 flex-align-center justify-md-right">
        <mat-form-field>
          <mat-label>Search</mat-label>
          <input matInput placeholder="Placeholder" />
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
        <button
          mat-raised-button

          class="ml-2 ml-sm-auto"
          >
          Advanced Search
        </button>
      </div>
    </div>
  </div>
</div>
